import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import Typography from 'Components/UI/Typography';
import WelcomeParagraphs from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/WelcomeParagraphs';
import WelcomeBlurb from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/WelcomeBlurb';
import WelcomeLowerContentWrapper
  from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/WelcomeLowerContent/WelcomeLowerContentWrapper';
import { useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const WelcomeLowerContentWithParagraphsAndWelcomeBlurb = ({
  resource,
}) => {
  const theme = useTheme();
  return (
    <WelcomeLowerContentWrapper>
      {resource.attr('primaryText')
        ? (
          <Typography
            style={{
              fontSize: 32,
              marginTop: theme.spacing(3),
            }}
            variant={'h1'}
            color={'primary'}
            weight={'medium'}
          >
            {resource.attr('primaryText')}
          </Typography>
        ) : null}
      <WelcomeParagraphs
        paragraphs={resource.attr('secondaryText').map((text) => {
          return { text };
        })}
      />
      <WelcomeBlurb
        title={resource.attr('informationText')}
        bullets={
          resource.attr('informationDescriptions').map((description) => {
            return { text: description };
          })
        }
      />
    </WelcomeLowerContentWrapper>
  );
};

WelcomeLowerContentWithParagraphsAndWelcomeBlurb.defaultProps = {
};

WelcomeLowerContentWithParagraphsAndWelcomeBlurb.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default WelcomeLowerContentWithParagraphsAndWelcomeBlurb;
